 document.addEventListener("DOMContentLoaded", function() {
  // Check if the current URL ends with /vip-black-friday
  
  if (window.location.pathname.endsWith("/pages/vip-black-friday")) {
  // Set cart attributes via Shopify's cart.js endpoint
  fetch('/cart.js', {
  method: 'POST',
  headers: {
  'Content-Type': 'application/json',
  'Accept': 'application/json'
  },
  body: JSON.stringify({
  attributes: {
  "black-friday-preview": "true"
  }
  })
  })
  .then(response => {
  if (!response.ok) throw new Error('Failed to update cart attributes');
  return response.json();
  })
  .then(data => {
  console.log('Cart attribute updated:', data);
  })
  .catch(error => console.error('Error:', error));
  }
});

 